import { render, staticRenderFns } from "./posterAtlasDetall.vue?vue&type=template&id=9e6633c6&scoped=true&"
import script from "./posterAtlasDetall.vue?vue&type=script&lang=js&"
export * from "./posterAtlasDetall.vue?vue&type=script&lang=js&"
import style0 from "./posterAtlasDetall.vue?vue&type=style&index=0&id=9e6633c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6633c6",
  null
  
)

export default component.exports